
<template>
  <div class="bg-grey-lines block-fullscreen">
    <div class="header-logo">
      <icon name="td-logo" color="#393f49" />
    </div>
    <section class="block-fullscreen-center conclution">
      <div class="block-column conclution-description">
        <h1 class="title"><span class="active">Obrigado</span> por participar do teste de maturidade digital!</h1>
        <h2 class="sub-title">Esperamos que, a partir daqui, você consiga enxergar melhor como evoluir na jornada rumo à Transformação Digital.</h2>
        <div class="description">
          Disponilizamos o resultado do seu teste
          <div class="small">além de enviá-lo para o e-mail cadastrado.</div>
        </div>
      </div>
      <div class="block-column conclution-go">
        <div class="conclution-button">
          <div class="conclution-square"></div>
          <router-link :to="nextScreen" class="title">
            <span>Ver resultado</span>
            <icon name="arrow-line-middle" width="60px" />
          </router-link>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Icon from '../Icon';

export default {
  name: 'conclution',
  components: { Icon },
  data() {
    return {
      nextScreen: '/teste/resultado',
      allData: this.$store.getters.data,
      userid: this.$store.state.userid,
      usercode: this.$store.state.usercode,
      submitted: this.$store.state.submitted,
    };
  },
  mounted() {
    this.$store.commit('TEST_CALCULATE_OVERALL')
  
    if (this.userid) {

      const data = {
        cultura_e_lideranca: this.$store.state.cultura_e_lideranca,
        experiencia_do_cliente: this.$store.state.experiencia_do_cliente,
        empreendedorismo_digital: this.$store.state.empreendedorismo_digital,
        tecnologia_digital: this.$store.state.tecnologia_digital,
        agilidade_operacional: this.$store.state.agilidade_operacional,
        test_results: this.$store.state.test_results,
        submitted: true
      }

      try {
        this.$http.post('/api/user/' + this.userid + '/' + this.usercode, data)
        .then(response => { }, response => {
          this.$store.commit('REQUEST_ERROR', true);
        });
      } catch(e) {
        this.$store.commit('REQUEST_ERROR', true);
      }
      
    } else {
      this.$store.commit('REQUEST_ERROR', true);
    }
  },
};
</script>

<style lang="scss" scoped>
  .block-fullscreen {
    overflow: hidden;
    @media (max-width: 576px) {
      overflow-y: auto;
    }
  }
  .conclution {
    flex-direction: row;
    margin: 0 160px;
    @media (max-width: 576px) {
      overflow: hidden;
      flex-direction: column;
      margin: 110px 15px 0;
      padding-bottom: 200px;
    }
    @media (min-width: 576px) and (max-width: 991px) {
      margin: 0 24px;
    }
  }
  .conclution-description {
    .title {
      text-transform: uppercase;
      font-size: 48px;
      letter-spacing: 4px;
      line-height: 58px;
      .active {
        position: relative;
        &:before {
          content: "";
          position: absolute;
          top: -5%;
          left: -6%;
          right: 0;
          bottom: 0;
          background-color: rgba(white, .102);
          height: 105%;
          width: 109%;
        }
      }
    }
    .sub-title {
      letter-spacing: 1px;
      line-height: 32px;
      padding-right: 42px;
      margin: 0;
    }
    .description {
      &:before {
        content: "";
        background-color: rgba(white, .5);
        height: 1px;
        width: 120%;
        display: block;
        margin: 32px 0;
      }
      font-size: 1.5em;
      letter-spacing: 1px;
      line-height: 32px;
      .small {
        letter-spacing: 3px;
        font-size: 15px;
        text-transform: uppercase;
      }
    }
  }
  .conclution-go {
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: 576px) {
      margin-top: 164px;
    }
  }
  .conclution-button {
    position: relative;
    width: 200px;
    height: 200px;
    display: flex;
    justify-content: center;
    align-items: center;
    .conclution-square {
      position: absolute;
      transform: rotate(45deg);
      background-color: rgba(white, .2);
      width:100%;
      height: 100%;
      &:before,
      &:after {
        content: "";
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        box-shadow: 0 0 0 1px rgba(white, .1);
        animation: scale-square 6s infinite normal cubic-bezier(1,.48,.52,.98);
      }
      &:after {
        animation-delay: 3s;
      }
    }
    .title {
      text-transform: uppercase;
      text-decoration: none;
      color: white;
      font-size: 24px;
      letter-spacing: 6px;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      width:100%;
      height: 100%;
      padding: relative;
      z-index: 1;
      .icon {
        transition: right .3s;
        position: absolute;
        right: -70px;
      }
      &:hover .icon {
        right: -85px;
      }
    }
  }
  @keyframes scale-square {
    0% { transform: scale(1) rotate(0); opacity: 0 }
    20% { opacity: 1 }
    70% { opacity: 1 }
    80% { opacity: 0 }
    100% { transform: scale(6) rotate(35deg); opacity: 0 }
  }
</style>



// WEBPACK FOOTER //
// src/components/test/Conclusion.vue